/* eslint-disable */
// http://docs.translatehouse.org/projects/localization-guide/en/latest/l10n/pluralforms.html
import {TLanguage} from '../interfaces/language';

export const PLURAL_FORMS: Record<TLanguage | string, (n: number) => number > = {
  /** nplurals=3; */
  uk: (n: number) => (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
  /** nplurals=3; */
  ru: (n: number) => (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
  /** nplurals=3; */
  pl: (n: number) => (n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
  /** nplurals=2; */
  en: (n: number) => (n !== 1 ? 1 : 0),
  /** nplurals=2; */
  de: (n: number) => (n !== 1 ? 1 : 0),
  /** nplurals=2; */
  es: (n: number) => (n !== 1 ? 1 : 0),
  /** nplurals=2; */
  fr: (n: number) => (n > 1 ? 1 : 0),
  /** nplurals=3; */
  hr: (n: number) => (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
  /** nplurals=2; */
  it: (n: number) => (n !== 1 ? 1 : 0),
  /** nplurals=3; */
  lt: (n: number) => (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
  /** nplurals=2; */
  nl: (n: number) => (n !== 1 ? 1 : 0),
  /** nplurals=3; */
  ro: (n: number) => (n === 1 ? 0 : n === 0 || (n % 100 > 0 && n % 100 < 20) ? 1 : 2),
  /** nplurals=3; */
  lv: (n: number) => (n % 10 === 1 && n % 100 !== 11 ? 0 : n !== 0 ? 1 : 2),
  /** nplurals=1; */
  ka: (n: number) => 0, // В грузинській немає множини
  /** nplurals=3; */
  cs: (n: number) => (n === 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2),
};

export const PLURAL_FORM_NAMES = ['one', 'two', 'many'];
